import { useEffect, useRef } from "react";
import { useLogout } from "./useLogout";
import { getUserProfile } from "../Common/data/getUserProfile";

const useBioDataStatusCheck = () => {
  const logout = useLogout();
  const previousBioDataStatusRef = useRef<string | null>(null); // Initialize with null

  useEffect(() => {
    const checkBioDataStatus = async () => {
      try {
        const userProfile = await getUserProfile();
        
        // Access bioDataStatus from the results object
        const currentBioDataStatus = userProfile.results.bioDataStatus;

        console.log("User Profile:", userProfile); // Log user profile
        console.log("Previous Status:", previousBioDataStatusRef.current);
        console.log("Current Status:", currentBioDataStatus);

        // If this is the first time we are checking, just set the status without any action
        if (previousBioDataStatusRef.current === null) {
          previousBioDataStatusRef.current = currentBioDataStatus;
          return; // Exit here since this is the first load
        }

        // If the previous status was "pending" and the current is "verified," log the user out
        if (previousBioDataStatusRef.current === "pending" && currentBioDataStatus === "verified") {
          logout(); // Call the logout function
        }

        // Update the reference to the current status only if it is not the same as the previous one
        if (currentBioDataStatus !== previousBioDataStatusRef.current) {
          previousBioDataStatusRef.current = currentBioDataStatus;
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    const intervalId = setInterval(checkBioDataStatus, 5000); // Check every 5 seconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [logout]);

};

export default useBioDataStatusCheck;
